import type { FC } from 'react';
import { Show } from '@components/Show';
import type { DbSubmissionBlock } from '@domain/schemas/block.schema';

interface BlockPermissionsSetProps {
  block: DbSubmissionBlock;
}

const getPermissionPrefix = (can: boolean = true) => (can ? 'Can' : 'Cannot');
const isEntra = import.meta.env?.VITE_AUTH_METHOD === 'entra';

export const BlockPermissionsSet: FC<BlockPermissionsSetProps> = ({ block }) => {
  const { canDelete = true, canDeleteOnTemplate = true, canEdit = true, canEditOnTemplate = true } = block;

  return (
    <div className="flex flex-col gap-0.5 font-medium">
      <p className="mb-1 font-bold">Permissions Set</p>
      <Show when={!canEditOnTemplate && !isEntra}>
        <p>Super Admin edit only</p>
      </Show>
      <Show when={!isEntra}>
        <p>{getPermissionPrefix(canDeleteOnTemplate)} be removed from templates</p>
      </Show>
      <p>{getPermissionPrefix(canEdit)} be edited on contracts</p>
      <p>{getPermissionPrefix(canDelete)} be removed from contracts</p>
    </div>
  );
};
